import * as api from  '@/api/situation'
import * as TYPES from './type';

export default {
  //学校概览
  async getSchoolOverview({ commit, state }, { paramets, cb }) {
    const result = await api.reqSchoolOverview(paramets)
    commit(TYPES.SCHOOL_OVERVIEW, { result })
    cb && cb()
  },
  //课件资源占比
  async getCourseware({ commit, state }, { paramets, cb }) {
    const result = await api.reqCourseware(paramets)
    commit(TYPES.COURSEWARE_RESOURCE, { result })
    cb && cb()
  },
  //活动参与率
  async getActivityProportion({ commit, state }, { paramets, cb }) {
    const result = await api.reqActivityProportion(paramets)
    commit(TYPES.ACTIVITY_PROPORTOPN, { result })
    cb && cb()
  },
  //周到课率
  async getAttendance({ commit, state }, { paramets, cb }) {
    const result = await api.reqAttendance(paramets)
    commit(TYPES.ATTENDANCE, { result })
    cb && cb()
  },
  //成绩分析
  async getAchievementAnalysis({ commit, state }, { paramets, cb }) {
    const result = await api.reqAchievementAnalysis(paramets)
    commit(TYPES.ACHIEVEMENT_ANALYSIS, { result })
    cb && cb()
  },
  //系部资源
  async getDepartmentResource({ commit, state }, { paramets, cb }) {
    const result = await api.reqDepartmentResource(paramets)
    commit(TYPES.DEPARTMENT_RESOURCE, { result })
    cb && cb()
  },
  //系部资源
  async getSdeptProportionDetails({ commit, state }, { paramets, cb }) {
    const result = await api.reqSdeptProportionDetails(paramets)
    commit(TYPES.DEPARTMENT_RESOURCE_DETAILS, { result })
    cb && cb()
  },
}



// WEBPACK FOOTER //
// ./src/store/situation/actions.js